var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVoltar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140 -639)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(140 639)",
    fill: "#0c1151",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.975 644.822)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.494,352.169v22.684L397.757,363.51Z",
    transform: "translate(-397.757 -352.169)",
    fill: "#0c1151"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.146 5.671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.89,384.453s-.872-18.1-22.9-22.684v11.342S373.6,370.929,381.89,384.453Z",
    transform: "translate(-358.988 -361.769)",
    fill: "#0c1151"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoltar);
export default __webpack_public_path__ + "static/media/icon-voltar.aa7b7c59abe7ede920e40df16059d9c0.svg";
export { ForwardRef as ReactComponent };